<script>
import { defineComponent } from 'vue';
import { useMarketingFilters } from '../composables/useMarketingFilters';

export default defineComponent({
  name: 'PageFiltersOutlet',
  setup() {
    const { pageFilters } = useMarketingFilters();
    return () => {
      void pageFilters.version;
      return pageFilters.render?.() ?? null;
    };
  }
});
</script>
